//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.description
        }
      ],
    }
  },
    watch: {
     '$route': function (value) {
       this.$fetch();
      }
    },
  async fetch() {
    try {
      //seo
      let seo = await this.$content().get('seo', {
        params: {
          path: this.$route.path,
        }
      })
      seo =  seo.data.data
      this.$store.commit('seo/setData', seo)

      //globals
      // let globals = await this.$cms().get('global?populate=footer_partners.image.*&locale=' + this.lang)
      // this.$store.commit('setGlobals', _.get(globals, 'data.data.attributes'))

    } catch(e) {}
  },
    computed: {
    title() {
      try {
        return _.get(this.$store.state, 'seo.title', '')
      } catch(e){}
      return "";
    },
    description() {
      try {
        return _.get(this.$store.state, 'seo.description', '')
      } catch(e){}
      return "";
    }
  },
}
